import React from 'react';
import { Section } from 'components';
import * as styles from './styles.module.scss';

const FiveColumnTable = ({ data }) => {
  return (
    <Section className={styles.fiveColTable} sliceName="FiveColumnTable" noContainer>
      <div className={styles.fiveColTableDiv}>
        {data.items.map((item) => {
          return (
            <div key={item.idx} className={styles.fiveColTableContainer}>
              <div className={styles.colOne}>{item.columnone.text}</div>
              <div className={styles.colTwo}>{item.columntwo.text}</div>
              <div className={styles.colThree}>{item.columnthree.text}</div>
              <div className={styles.colFour}>{item.columnfour.text}</div>
              <div className={styles.colFive}>{item.columnfive.text}</div>
            </div>
          );
        })}
      </div>
    </Section>
  );
};

export default FiveColumnTable;
